import { MovingUnderlineNav } from "@/components/moving-underline-nav";
import { PageContent, PageHeader } from "@/components/page-components";
import { Button } from "@papier/ui/components/ui/button";
import { createFileRoute, Link, linkOptions, Outlet } from "@tanstack/react-router";
import { CreditCard, KeyRound, Settings, Users } from "lucide-react";

export const Route = createFileRoute("/_app/organization")({
  component: RouteComponent,
  head: () => ({
    meta: [{ title: "Papier - Organization" }],
  }),
});

const navigationItems = linkOptions([
  { to: "/organization/settings", title: "Settings", icon: Settings },
  { to: "/organization/members", title: "Members", icon: Users },
  { to: "/organization/api-keys", title: "API Keys", icon: KeyRound },
  { to: "/organization/billing", title: "Billing", icon: CreditCard },
]);

function RouteComponent() {
  return (
    <>
      <PageHeader>
        <div className="no-scrollbar overflow-x-auto px-4 pt-1">
          <MovingUnderlineNav>
            {navigationItems.map((item) => {
              return (
                <Button asChild key={item.title} variant="ghost">
                  <Link
                    to={item.to}
                    className="hover:bg-transparent! relative rounded-none px-4 py-2 transition-colors duration-300 ease-in-out"
                    inactiveProps={{
                      className: "text-muted-foreground hover:text-accent",
                    }}
                    activeProps={{
                      className: "text-foreground",
                    }}
                    activeOptions={{ exact: true, includeSearch: false }}
                  >
                    <item.icon className="size-4" />
                    <span>{item.title}</span>
                  </Link>
                </Button>
              );
            })}
          </MovingUnderlineNav>
        </div>
      </PageHeader>

      <PageContent className="mx-auto w-full max-w-7xl">
        <Outlet />
      </PageContent>
    </>
  );
}
